<script lang="ts">
    import { sprache } from "../store"
    import Lightbox from "./Lightbox.svelte"

    export let file: Media
</script>

<div class="grid-item" data-type="{file.external?.type || file.file?.type}">
    <Lightbox m="{file}" />

    <div class="item-content">
        <h4>
            {@html (file.title && file.title[$sprache]) || "<span class='filename'>" + file.filename + "</span>"}
        </h4>
        <p>{(file.author && file.author[$sprache]) || ""}</p>
        {#if file.file?.type == "image/jpeg" || file.file?.type == "image/png"}
            <!-- svelte-ignore a11y-missing-content -->
            <a
                href="/api/media/{file.id}/{file.preview?.src || file.file?.src}?filter=l"
                target="_blank"
                class="icon download"
                download="{file.filename}"></a>
        {/if}
        {#if file.file?.type == "application/pdf"}
            <!-- svelte-ignore a11y-missing-content -->
            <a
                href="/api/media/{file.id}/{file.file?.src}"
                class="icon download"
                target="_blank"
                download="{file.filename}"></a>
        {/if}
    </div>
</div>
